// Cart sets: "Hide all N items" / "Show all N items" next to "Set N" (snippets/cart-build-box-group.liquid).
// Complete sets start collapsed (.is-collapsed rendered by Liquid, so nothing flashes open after a cart update;
// merchant, Nov 3 2026): new sets, copies added with + and the set they came from all stay closed. Only sets the
// shopper opened with "Show all N items" stay open; that choice is kept per set (_bb id) in localStorage, shared by
// every tab (merchant, Oct 28 2026: tabs already open update live). Editing a set (Edit) always shows it.
(() => {
  if (window.WZ_setHide) return;
  window.WZ_setHide = true;
  const KEY = 'wzShownSets';
  const read = () => {
    try { return JSON.parse(localStorage.getItem(KEY) || sessionStorage.getItem(KEY) || '[]'); } catch (e) { return []; }
  };
  const write = (list) => {
    list = list.slice(-40); // old sets drop off
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) { /* private mode: still works until reload */ }
    mem = list;
  };
  let mem = read();
  // Kept for assets/set-qty.js: a copy added with + stays closed.
  window.WZ_hideSet = (id) => { if (id && mem.includes(id)) { write(mem.filter((x) => x !== id)); apply(); } };

  // Sets still being filled (no "Hide all" link while slots are empty) are never collapsed.
  const collapsible = (group) => !!group.querySelector('[data-bb-qty]');

  function apply() {
    document.querySelectorAll('[data-bb-group]').forEach((group) => {
      const on = collapsible(group) && !mem.includes(group.dataset.bbGroup) && !group.classList.contains('is-arranging');
      if (group.classList.contains('is-collapsed') !== on) group.classList.toggle('is-collapsed', on);
      const btn = group.querySelector('[data-bb-hide]');
      if (!btn) return;
      const want = on ? btn.dataset.showLabel : btn.dataset.hideLabel;
      const text = btn.querySelector('[data-bb-hide-text]');
      if (text && text.textContent !== want) text.textContent = want;
      const expanded = String(!on);
      if (btn.getAttribute('aria-expanded') !== expanded) btn.setAttribute('aria-expanded', expanded);
    });
  }

  document.addEventListener('click', (event) => {
    const btn = event.target.closest('[data-bb-hide]');
    if (btn) {
      const id = btn.closest('[data-bb-group]')?.dataset.bbGroup;
      if (!id) return;
      write(mem.includes(id) ? mem.filter((x) => x !== id) : [...mem, id]);
      apply();
      // "Show all N items" also opens Gift Options; "Hide all N items" closes it (merchant, Oct 28 2026).
      const group = btn.closest('[data-bb-group]');
      const shown = mem.includes(id);
      group?.querySelectorAll('[data-gift-panel]').forEach((panel) => {
        panel.hidden = !shown;
        if (shown) {
          const body = panel.querySelector('.sgo-body');
          if (body) body.hidden = false;
          panel.querySelector('[data-gift-min]')?.setAttribute('aria-expanded', 'true');
        }
        const link = group.querySelector(`[data-gift-open="${CSS.escape(panel.dataset.giftPanel)}"]`);
        if (link) {
          link.setAttribute('aria-expanded', String(shown));
          const label = shown ? link.dataset.hideLabel : link.dataset.showLabel;
          if (label) link.textContent = label;
        }
      });
      return;
    }
    const edit = event.target.closest('[data-bb-arrange-edit]');
    if (edit) {
      // After Done the edited set stays open, as before.
      const id = edit.dataset.bbArrangeEdit;
      if (id && !mem.includes(id)) write([...mem, id]);
      setTimeout(apply, 0);
    }
  }, true);

  // Another tab opened or closed a set: follow it here too.
  window.addEventListener('storage', (event) => {
    if (event.key !== KEY) return;
    mem = read();
    apply();
  });

  let queued = false;
  new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; apply(); });
  }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  apply();
})();
